import { z } from "zod";

const clientEnvSchema = z.object({
  // 必填：核心基础设施
  VITE_APP_URL: z.string().min(1),
  VITE_SUPABASE_URL: z.string().min(1),
  VITE_SUPABASE_ANON_KEY: z.string().min(1),

  // 可选：Web3 / Privy（MVP 阶段未启用）
  VITE_PRIVY_APP_ID: z.string().optional().default(""),
  VITE_PRIVY_CLIENT_ID: z.string().optional().default(""),
  VITE_BASE_CHAIN_ID: z.string().optional().default(""),
  VITE_BASE_RPC_URL: z.string().optional().default(""),
  VITE_USDC_TOKEN_ADDRESS: z.string().optional().default(""),
  VITE_PLATFORM_WALLET_ADDRESS: z.string().optional().default(""),
  VITE_WALLETCONNECT_PROJECT_ID: z.string().optional().default(""),
});

type ClientEnv = z.infer<typeof clientEnvSchema>;

export function validateClientEnv(input: Record<string, string | undefined>): ClientEnv {
  return clientEnvSchema.parse(input);
}
